import axios from "axios";
import localStorage from "redux-persist/es/storage";

import { LOGIN_PATH, REFRESH_PATH } from "./constants";
import { AuthRefreshTokenResponseService } from "../../services/auth/AuthenticationServices.type";
import { CLEAR_AUTH } from "../../store/auth/actionTypes";
import { getStore } from "../../store/store";
import {
  FRANCHISE_HEADER,
  getFranchiseHeaderValue,
  getPersistStorageKey,
  getTokenStorageKey,
  resolveFranchiseSlugFromPath,
} from "../franchise/franchiseSlug";

export async function getTokensLocalStorage() {
  const persistKey = getPersistStorageKey();
  const LavorisStorage = await localStorage.getItem(`persist:${persistKey}`);
  const { auth } = LavorisStorage ? JSON.parse(LavorisStorage) : null;
  const tokens = auth ? JSON.parse(auth) : null;
  return tokens;
}

export async function removeTokensLocalStorage() {
  window.localStorage.removeItem(`persist:${getPersistStorageKey()}`);
  window.localStorage.removeItem(getTokenStorageKey());
  getStore()?.dispatch({ type: CLEAR_AUTH });
}

export const getNewTokensUsingRefresh = async () => {
  const tokens = getTokens();
  const franchiseSlug = getFranchiseHeaderValue();
  return axios.request({
    method: "post",
    url: `${process.env.REACT_APP_API_LAVORIS_URL}${process.env.REACT_APP_API_LAVORIS_VERSION}/auth/refresh`,
    headers: {
      Authorization: `Bearer ${tokens?.refresh_token}`,
      ...(franchiseSlug ? { [FRANCHISE_HEADER]: franchiseSlug } : {}),
    },
  });
};

export const reTryRequest = async (
  errorConfig: any,
  newHeaders: any,
): Promise<any> => {
  errorConfig.headers = newHeaders;

  const axiosRequest = await axios.request(errorConfig);

  return axiosRequest.data;
};

export const getTokens = (): AuthRefreshTokenResponseService | null => {
  const tokensRaw = window.localStorage.getItem(getTokenStorageKey());
  return tokensRaw && JSON.parse(tokensRaw);
};

export const setNewTokens = (
  newValues: AuthRefreshTokenResponseService,
): void => {
  const tokensStringify = JSON.stringify(newValues);

  window.localStorage.setItem(getTokenStorageKey(), tokensStringify);
};

export const getAuthErrorStatus = (error: any): number | undefined => {
  return (
    error?.response?.data?.statusCode ?? error?.response?.status ?? error?.statusCode
  );
};

export const isAuthError = (error: any): boolean => {
  const status = getAuthErrorStatus(error);
  return status === 401 || status === 403;
};

export const redirectToLogin = (): void => {
  const sociosMatch = window.location.pathname.match(/^\/socios\/([^/]+)/i);
  const slug = sociosMatch?.[1]?.toLowerCase();
  const base =
    slug && slug !== "lavoris" && slug !== "root" ? `/socios/${slug}` : "";
  window.location.replace(`${window.location.origin}${base}/login`);
};

export const logoutUser = async (): Promise<void> => {
  await removeTokensLocalStorage();
  redirectToLogin();
};

export const clearStorageAndRedirectToLogin = async (
  error: any,
): Promise<void> => {
  if (!isAuthError(error)) return Promise.reject(error);

  await logoutUser();
};

export const shouldNotRetry = (errorData: any) => {
  const errorIsNotUnauthorized =
    (errorData.statusCode === 401 || errorData.statusCode === 403) &&
    errorData.path !== `${REFRESH_PATH}`;

  const errorIsLogin = errorData.path === `${LOGIN_PATH}`;

  return !errorIsNotUnauthorized || errorIsLogin;
};
